import { useTranslation } from "react-i18next";
import Dropdown from "react-bootstrap/Dropdown";
import SortingSelector, {
  SortProperty,
} from "../SortingSelector/SortingSelector";
import FilteringSelector from "../FilteringSelector/FilteringSelector";
import { Column, FilterInput } from "../List/List";

interface FilterProps {
  columns: Array<Column>;
  currentSort: SortProperty;
  onSortChange: Function;
  filterInputs: Array<FilterInput>;
  onFilterChange: Function;
}

const showSort = (columns: Array<Column>) => {
  for (let column of columns) {
    if (column.sortable) {
      return true;
    }
  }
  return false;
};

export default function Filter(props: FilterProps) {
  const { t } = useTranslation();

  return (
    <table className="container bg-white rounded-top">
      <tbody>
        <tr>
          {props.filterInputs && props.filterInputs.length > 0 && (
            <td className="p-4">
              <Dropdown className="borderless-dropdown">
                <Dropdown.Toggle className="font-weight-600-button text-gray-36">
                  {t("Filter")}
                </Dropdown.Toggle>
                <FilteringSelector
                  filterInputs={props.filterInputs}
                  onFilterChange={props.onFilterChange}
                />
              </Dropdown>
            </td>
          )}
          {showSort(props.columns) && (
            <td className="p-4 text-end">
              <Dropdown className="borderless-dropdown">
                <Dropdown.Toggle className="font-weight-600-button text-gray-36">
                  {t("Sort by")}
                </Dropdown.Toggle>
                <SortingSelector
                  columns={props.columns}
                  currentSort={props.currentSort}
                  onSortChange={props.onSortChange}
                />
              </Dropdown>
            </td>
          )}
        </tr>
      </tbody>
    </table>
  );
}
